<template>
  <div>
    <div class="row">
      <div class="col-8">
        <h1>
          {{ properties.group === 'PCP' ? 'Junção' : 'Rede' }} -
          {{ idJuncao || '' }}
        </h1>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => $emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left"> Voltar</md-tooltip>
        </md-button>
      </div>
    </div>

    <div v-if="editable" style="text-align: right">
      <md-button
        class="md-primary md-accent"
        @click="
          $emit('delete', {
            group: properties.group,
            original: properties,
          })
        "
      >
        Delete
      </md-button>
      <md-button
        class="md-primary md-raised"
        @click="
          $emit('save', {
            group: properties.group,
            changed: changed,
            original: properties,
          })
        "
      >
        Salvar
      </md-button>
    </div>

    <md-table>
      <md-table-row>
        <md-table-head>Propriedade</md-table-head>
        <md-table-head md-numeric> Valor</md-table-head>
      </md-table-row>
      <md-table-row v-for="(value, index) in properties" :key="index">
        <md-table-cell>{{ traducao[index] || index }}</md-table-cell>
        <md-table-cell md-numeric>
          <b v-if="canEdit(index) === false">
            {{
              getPropertyValue(
                typeof value === 'string' ? value : (+value).toFixed(2),
                index
              )
            }}
          </b>

          <div>
            <md-field v-if="canEdit(index)">
              <label>{{ traducao[index] || index }}</label>
              <md-input
                style="text-align: right"
                :value="value"
                number
                @input="(e) => handleInput(e, index)"
              ></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
const EDITABLE_GOUPS = {
  PCP: {
    elevation: true,
    basedemand: true,
    emitter: true,
    pattern: true,
    initvolume: true,
    diameter: true,
    minvolume: true,
    maxvolume: true,
    tanklevel: true,
  },
  LINE: {
    diameter: true,
    length: true,
    roughness: true,
  },
}

export default {
  name: 'EpanetHeatmapHistorico',
  props: {
    idJuncao: {
      type: String,
      default: '',
    },
    properties: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      changed: {},
      traducao: {
        basedemand: 'Demanda Base',
        demand: 'Demanda',
        elevation: 'Elevação',
        emitter: 'Emissor',
        head: 'Carga Hidráulica',
        pressure: 'Pressão',
        pattern: 'Padrão de consumo',
        group: 'Grupo',
        velocity: 'Velocidade',
        type: 'Tipo',
        to: 'Para',
        status: 'Status',
        roughness: 'Rugosidade',
        minorloss: 'Perda Menor',
        length: 'Comprimento',
        initstatus: 'Status Inicial',
        headloss: 'Perda De Carga',
        Grupo: 'Grupo',
        from: 'De',
        flow: 'Vazão',
        diameter: 'Diâmetro',
        nodetype: 'Tipo Nó',
      },
    }
  },
  watch: {
    properties: {
      immediate: true,
      handler(newValue) {
        this.changed = {}
      },
    },
  },
  methods: {
    getPropertyValue(value, property) {
      switch (property) {
        case 'nodetype':
          switch (+value) {
            case 0:
              return 'Junção'
            case 1:
              return 'Reservatório'
            case 2:
              return 'Tanque'
            default:
              return value
          }
        default:
          return value
      }
    },
    handleInput(e, index) {
      this.changed[index] = e
    },
    canEdit(property) {
      if (this.editable) {
        if (this.properties.group === 'PCP') {
          return EDITABLE_GOUPS.PCP[property] || false
        } else if (this.properties.group === 'LINE') {
          return EDITABLE_GOUPS.LINE[property] || false
        }
      }
      return false
    },
  },
}
</script>
